import TextField from '@mui/material/TextField';
import { createStyles, makeStyles } from '@mui/styles';
import ZTextBox from '../components/ZTextBox';
import ZGrid from '../components/ZGrid';
import Paper from '@mui/material/Paper';
import image from '../asset/images/background.jpg'
import logo from '../asset/images/banklogo.png'
import authentication from '../asset/images/Authentication.svg'
import scanner from '../asset/images/camera.png'
import ZButton from '../components/ZButton';
import ZTypography from '../components/ZTypography';
import classNames from 'classnames';
import Hidden from '@mui/material/Hidden';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";

function Login(props) {
    const classes = props.classes
    let history = useHistory();

    const handleClick = () => {
        history.push("/dashboard");
    }

    return (
        <ZGrid>
            <ZGrid item md={12} className={classes.logo}>
                <div className={classes.logoContainer}>
                    <div>
                        <img src={logo} />
                    </div>
                    <div className={classes.welcome}>
                        <span className={classes.fontWeight}>Welcome to net Banking</span>
                    </div>
                </div>
            </ZGrid>

            <ZGrid container className={classes.loginContainer} xs={12}>
                <ZGrid className={classes.cardContainer} xs={12} md={11} >
                    <ZGrid container className={classes.security}>
                        <ZGrid item xs={12} md={6} lg={6} xl={6} className={classes.cardWelcome}>
                            <ZGrid item sm={12} md={10} >
                                <div className={classes.welcome}>
                                    <span className={classes.fontWeight}>Login to net Banking</span>
                                </div>
                                {/* <div  className={classes.textField}>      
                                        <TextField className={classes.miriID} style={{width: "100%"}}
                                            id="outlined-password-input"
                                            label="Enter Miri ID or scan QR code"
                                            />
                                         <span>
                                        <img src={scanner} height={30} className={classes.scanner}/>
                                        </span>
                                        
                                    </div> */}

                                <div style={{ display: "flex", width: "100%", marginBottom: 15 }}>
                                    <TextField variant="standard"
                                        inputProps={{
                                            autoComplete: 'off',
                                            maxLength: 19,
                                            style: { textTransform: "uppercase" }
                                        }}

                                        style={{ width: "100%" }}
                                        id="standard-basic"
                                        label="Enter Vken Sign-In or Scan Vken Sign-In QR Code"
                                        className={classes.root}
                                    />
                                    <div
                                        style={{
                                            borderBottom: "1px solid rgba(0, 0, 0,0.42)",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <img
                                            src={scanner}
                                            style={{ width: 30, height: 30, marginTop: 10 }}
                                        ></img>
                                    </div>
                                </div>

                                <div className={classes.logbg} style={{}}></div>
                            </ZGrid>

                            <ZGrid item md={12} >
                                <div className={classes.dflex} onClick={() => { handleClick() }}>
                                    <ZButton variant="contained"
                                        color="primary" name="Login" className={classes.btnLogin}></ZButton>
                                    {/* <span className={classes.forgotPassword}>Forgot password?</span> */}
                                </div>
                            </ZGrid>

                            <ZGrid item xs={12} md={12}>
                                <ZGrid item xs={12} md={10}>
                                    <ZTypography className={classes.featureHeader}>
                                        get a secure payment service
                                    </ZTypography>
                                </ZGrid>

                                <ZGrid className={classes.featurecardContainer} item xs={12} md={12} style={{ background: "#fff" }}>

                                    <div>
                                        <div className={classes.securityFeatures}> Built-in Two-Factor Authentication</div>
                                        <div className={classes.securityFeatures}> Help customers to login securely</div>
                                        <div className={classes.securityFeatures}>
                                            Secure Identification, Authorization & Authentication
                                        </div>
                                    </div>
                                </ZGrid>
                            </ZGrid>
                        </ZGrid>


                        <ZGrid item xs={12} md={6} lg={6} xl={6} className={classes.serviceCard}>
                            <div className={classes.welcome}>
                                <span className={classes.fontWeight}> We have added a host of new features!</span>
                            </div>

                            <div className={classes.featureSubHeader}>
                                You can now do so much more:
                            </div>

                            <div>
                                <div className={classes.securityFeatures}> Available as a Local App for mobile platforms</div>
                                <div className={classes.securityFeatures}> Enable users to send/receive money almost instantly </div>
                                <div className={classes.securityFeatures}>
                                    Unique Secure ID Number for each Transaction
                                </div>
                                <div className={classes.securityFeatures}>
                                    Payment is processed only upon confirmation
                                </div>
                                <div className={classes.securityFeatures}>
                                    You never need forgot password option
                                </div>
                            </div>
                        </ZGrid>

                    </ZGrid>

                </ZGrid>
                {/* 
                    <Hidden mdDown>
                        <ZGrid md={4} lg={4} xl={2} className={classes.imgauthenticate}>
                            <img src={authentication}/>
                        </ZGrid>
                    </Hidden> */}
            </ZGrid>
        </ZGrid>
    );
}


const styles = (theme) => ({

    root: {
        "& input:-webkit-autofill": {
            boxShadow: "0 0 0 30px #FFF0FFB2 inset",
        },

        "& label": {
            color: "rgba(0,0,0,0.5)",
            fontFamily: "Noto Sans",
            fontSize: 12.5,
            fontWeight: 600,
        },
        "& .MuiInputBase-input": {
            outline: "none",
        },

        "& .MuiInput-root": {
            outline: "none",
        },
        "& label.Mui-focused": {
            color: "rgba(0,0,0,0.5)",
        },
        "& .MuiInput-underline:after": {
            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        },
    },
    formControl: {
        width: "100%",
        // marginTop:10
    },

    loginContainer: {
        padding: "25px 0 0 0",
        display: "flex",
        justifyContent: "center",
        [theme.breakpoints.down('sm')]: {
            padding: 10
        }
    },

    featureSubHeader: {
        color: "#92278F",
        fontSize: 18,
        padding: "5px 0"

    },

    cardWelcome: {
        background: "#fff",
        borderTopLeftRadius: "0.75rem",
        padding: 30, paddingBottom: 0,
        [theme.breakpoints.only('xs')]: { padding: "10px 0px 10px 20px" },
        [theme.breakpoints.down('sm')]: {
            borderRadius: "0.75rem",

        }
    },

    securityFeatures: {
        padding: "10px 0px",
        '&:last-child': {
            paddingBottom: 0
        }
    },

    imgauthenticate: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        '& img': {
            height: "100%",
        },

        [theme.breakpoints.only('md')]: {
            justifyContent: "center",
            '& img': {
                height: "auto",
            },
        }
    },

    logoContainer: {
        // padding:"0.75rem 1.5rem",
        margin: "0px auto",

        '& div > img': {
            height: "5rem",
            width: "auto",
            userSelect: "none",
            margin: "5px auto 0px auto",
            display: "flex",
            justifyContent: "center",
        }

    },

    cardContainer: {
        //boxShadow: '0 10px 30px -3px rgb(0 0 0 / 5%), 0 4px 6px -2px rgb(0 0 0 / 5%)',
        //height: "50%",
        // margin: "auto",
        //position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        [theme.breakpoints.down('sm')]: {
            height: "25%"
        },

        '& > .security': {
            boxShadow: '0 20px 27px 0 rgb(0 0 0 / 5%)',
        }
    },

    featurecardContainer: {
        borderRadius: "0 0 0.75rem 0.75rem ",
        margin: "0 auto !important",
        left: 0,
        bottom: 0,
        right: 0,
        padding: "10px 0px 45px",
        [theme.breakpoints.only('xs')]: {
            padding: 20
        },
        [theme.breakpoints.down('sm')]: {
            height: "25%"
        },
        [theme.breakpoints.only('md')]: {
            margin: "15px 0 !important",
        },
    },

    textField: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // flexWrap:"wrap"
    },

    serviceCard: {
        background: "#fff",
        padding: 30,
        borderTopRightRadius: "0.75rem",
        paddingBottom: 0,
        [theme.breakpoints.down('sm')]: {
            padding: "30px 20px 20px",
            marginTop: 35
        },
    },

    txtWelcome: {
        fontWeight: 600,
        fontSize: 18,
        margin: 20,
        textTransform: "uppercase",
        fontFamily: "Noto Sans ",
    },

    logo: {
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",       
        background: "rgb(255, 255, 255)",
        margin: "2px 0 !important",
        boxShadow: "0 3px 10px rgb(0 0 0 / 20%)"

    },

    welcome: {
        margin: "20px 0",
        fontSize: 20
    },

    fontWeight: {
        fontWeight: 600,
        fontFamily: 'Josefin Sans',
        color: "#f7941d",
        textTransform: "uppercase"
    },

    scanner: {
        position: "relative",
        right: 30,
        display: "block",
        bottom: 10,
        cursor: "pointer"
    },

    logbg: {
        width: "100%",
        height: "100%",
        backgroundImage: `url(${image})`,
        // position:"absolute",
        // backgroundSize:"50% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderTopRightRadius: "0.75rem",
        borderBottomRightRadius: "0.75rem",
    },

    forgotPassword: {
        textDecoration: "line-through",
        color: "#303778",
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        fontSize: 14,
        marginLeft: 20,
        fontFamily: "Noto Sans ",
        color: "#92278F"
    },

    dflex: {
        display: "flex",
        margin: "20px 20px 40px 0px !important"
    },

    btnLogin: {
        background: "#303778",
        backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    },

    miriID: {
        width: "100%",
        margin: "0px 0px 20px 0px !important",

        '& label.MuiInputLabel-root': {
            color: "#9B9B9B",
            padding: 0, fontFamily: "Noto Sans ",
            lineHeight: 1,

        },

        '& input.MuiInputBase-input': {
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.87)",
            fontFamily: "Noto Sans ",
            marginRight: 40,
            [theme.breakpoints.down('xs')]: {
                fontSize: 14,
                marginRight: 40,
            }
        },

        '& label.MuiInputLabel-root.Mui-focused': {
            color: "#303778"
        },

        '& div.MuiInput-root:after': {
            borderBottom: "2px solid #303778"
        }
    },

    featureHeader: {
        fontSize: '18px !important',
        color: "#303778",
        // backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
        color: "#fff",
        textTransform: "uppercase",
        backgroundSize: "150%",
        backgroundPositionX: "25%",
        marginTop: "-20px !important",
        padding: 15,
        fontWeight: "600 !important",
        textAlign: "center",
        borderRadius: "0.75rem",
        background: "#fffbf7",
        background: "#FFF8FF",
        color: "#92278F",
        fontFamily: 'Josefin Sans !important',
    }
});

export default withStyles(styles)(Login);


